var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRequestList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.759,
    height: 19.514,
    viewBox: "0 0 10.759 19.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M6629.326,6510.376l9.256-9.256-9.256-9.256",
    transform: "translate(-6628.825 -6491.363)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 1.417
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequestList);
export default __webpack_public_path__ + "static/media/icon-request-list.6eb076eff392d9d563ddedb76fafadac.svg";
export { ForwardRef as ReactComponent };